const VisaSvg = ({
  height = 40,
  width = 28,
  viewBox = '0 0 40 28',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <rect x="0.5" y="0.5" width="39" height="27" rx="5.5" fill="white" stroke="#D9D9D9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1434 18.968H9.72014L7.90301 11.8912C7.81677 11.5656 7.63364 11.2779 7.36426 11.1422C6.69199 10.8013 5.9512 10.5301 5.14307 10.3932V10.1208H9.04669C9.58545 10.1208 9.98952 10.5301 10.0569 11.0054L10.9997 16.1102L13.4217 10.1208H15.7776L12.1434 18.968ZM17.1245 18.968H14.836L16.7204 10.1208H19.009L17.1245 18.968ZM21.9698 12.5717C22.0371 12.0952 22.4412 11.8228 22.9126 11.8228C23.6534 11.7544 24.4603 11.8912 25.1338 12.2309L25.5379 10.326C24.8644 10.0536 24.1236 9.91675 23.4513 9.91675C21.2302 9.91675 19.6139 11.1422 19.6139 12.843C19.6139 14.1369 20.7587 14.8163 21.5669 15.2256C22.4412 15.6337 22.7779 15.9061 22.7106 16.3142C22.7106 16.9264 22.0371 17.1988 21.3648 17.1988C20.5567 17.1988 19.7486 16.9948 19.009 16.6539L18.6049 18.5599C19.413 18.8996 20.2873 19.0365 21.0955 19.0365C23.586 19.1037 25.1338 17.8794 25.1338 16.0418C25.1338 13.7276 21.9698 13.592 21.9698 12.5717V12.5717ZM33.1431 18.968L31.3259 10.1208H29.3741C28.9701 10.1208 28.566 10.3932 28.4313 10.8013L25.0664 18.968H27.4223L27.8925 17.6753H30.7872L31.0566 18.968H33.1431ZM29.7109 12.5033L30.3831 15.8377H28.4987L29.7109 12.5033Z"
        fill="#172B85"
      />
    </svg>
  );
};
export default VisaSvg;
